const graphColors = [
  "#ff7f0e",
  "#2ca02c",
  "#8c564b",
  "#e377c2",
  "#bcbd22",
  "#17becf",
  // #1f77b4 - 25%
  "rgba(31, 119, 180, 0.65)",
  // #ff7f0e - 25%
  "rgba(255, 127, 14, 0.65)",
  // #2ca02c  - 25 %
  "rgba(44, 160, 44, 0.65)",
  // #d62728  - 25 %
  "rgba(214, 39, 40, 0.65)",
  // #9467bd  - 25 %
  "rgba(148, 103, 189, 0.65)",
  // #8c564b  - 25 %
  "rgba(140, 86, 75, 0.65)",
  // #e377c2  - 25 %
  "rgba(227, 119, 194, 0.65)",
  // #7f7f7f  - 25 %
  "rgba(127, 127, 127, 0.65)",
  // #bcbd22  - 25 %
  "rgba(188, 189, 34, 0.65)",
  // #17becf  - 25 %
  "rgba(23, 190, 207, 0.65)",
]

export default graphColors



// WEBPACK FOOTER //
// ./src/js/constants/colors.js